export default __webpack_public_path__ + "static/media/download_record_white.19a4b5ba.svg";